import React, { memo } from 'react';
import { SidebarBoundary } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/ui/sidebar-boundary/index.tsx';
import { SkeletonNavMenuItems } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/ui/skeleton-nav-menu-items/main.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { JpdProjectMenuProps } from './JpdProjectMenuContent.tsx';

const Skeleton = () => <SkeletonNavMenuItems />;

const LazyJpdProjectMenuContent = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-jira-navigation-apps-sidebar-nav4-sidebar-jpd-project-menu-content" */ './JpdProjectMenuContent.tsx'
		).then(({ JpdProjectMenuContent }) => JpdProjectMenuContent),
	{
		includeInShellOnlySsrBundle: true,
		entryFsSsrLiftImportToModule: true,
	},
);

export const AsyncJpdProjectMenuContent: React.MemoExoticComponent<
	(props: JpdProjectMenuProps) => React.JSX.Element
> = memo(
	(props: JpdProjectMenuProps): React.JSX.Element => (
		<SidebarBoundary
			id="nav4.sidebar.jpd-project-menu"
			packageName="jiraNavigationAppsSidebarNav4JPDProjectMenu"
			ufoName="nav4.sidebar.jpd-project-menu"
		>
			<Placeholder name="nav4.sidebar.jpd-project-menu" fallback={<Skeleton />}>
				<LazyJpdProjectMenuContent {...props} />
			</Placeholder>
		</SidebarBoundary>
	),
);
